module.exports = __webpack_public_path__ + "static/media/spotify-icon.82a07222.svg";